import InnerContainer from "@/components/ContentContainer/InnerContainer";
import FixedInput from "@/components/FixedInput";
import Skeleton from "@/components/Skeleton/Skeleton";
import useSmartQueryClient from "@/hooks/useSmartQueryClient";
import { CheckOutlined, DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Flex, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import _ from "lodash";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import DeletePackagingMaterialAction from "../DeletePackagingMaterialAction";
import { PackagingMaterial } from "../PackagingMaterialOverview/PackagingMaterialsOverview";
import { useGetPackagingMaterial, usePatchPackagingMaterial } from "../usePackagingMaterials";
import styles from "./PackagingMaterialDetail.module.scss";

export default function PackagingMaterialDetails({ materialId }: { materialId: number }) {
  const { data: material } = useGetPackagingMaterial({ materialId });
  const patch = usePatchPackagingMaterial();
  const smartQueryClient = useSmartQueryClient();
  const navigate = useNavigate();

  const saveName = useCallback((name: string) => {
    patch.mutateAsync({ materialId, patch: { name } });
  }, []);

  const debouncedSaveName = useMemo(() => _.debounce(saveName, 250), [saveName]);

  const updateName = (name: string) => {
    smartQueryClient.setQueryData<PackagingMaterial>(
      ["material", materialId, "details"],
      (material) => {
        return material
          ? {
              ...material,
              name,
            }
          : undefined;
      }
    );

    debouncedSaveName(name);
  };

  return (
    <InnerContainer
      title="Details"
      className={styles.MaterialDetails}
      contentClassName={styles.content}
    >
      <div className={styles.row}>
        Name
        <FixedInput
          value={material?.name}
          onChange={(name) => updateName(name)}
        />
      </div>
      <div className={styles.row}>
        Supplier
        <Input
          value={material?.supplier_name || ""}
          disabled={true}
        />
      </div>
      <div className={styles.row}>
        Supplier address
        <Flex
          align="center"
          gap={8}
        >
          <TextArea
            style={{ flexGrow: 1, height: 100 }}
            value={material?.supplier_address}
            disabled={true}
          />
        </Flex>
      </div>
      <div className={styles.buttons}>
        {material ? (
          <DeletePackagingMaterialAction
            materials={[material]}
            onSucces={() => navigate("/matching/packaging/materials")}
          >
            <Button
              style={{ textAlign: "left" }}
              disabled={material.packaging_relations > 0 || material.facility_relations > 0}
              danger
            >
              <DeleteOutlined /> Delete
            </Button>
          </DeletePackagingMaterialAction>
        ) : (
          <Skeleton style={{ width: "24px", height: "24px" }} />
        )}
        {patch.isLoading ? (
          <span>
            <LoadingOutlined /> Saving...
          </span>
        ) : (
          <span>
            <CheckOutlined /> Saved
          </span>
        )}
      </div>
    </InnerContainer>
  );
}
